import { ScrollArea, Tabs } from '@mantine/core';
import { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { ContentLayout } from '@features/layout';
import { ChartsTab } from './ChartsTab';
import classes from './MongoDashboard.module.css';
import { ReportsTab } from './ReportsTab';

interface MongoDashboardTab {
  value: string;
  label: string;
  component: React.ReactNode;
}

export const MongoDashboard = () => {
  const navigate = useNavigate();
  const { tabId } = useParams();

  const basePath = '/mongo-dashboard';

  const tabs: MongoDashboardTab[] = [
    {
      value: 'charts',
      label: 'Charts',
      component: <ChartsTab />,
    },
    {
      value: 'reports',
      label: 'Reports',
      component: <ReportsTab />,
    },
  ];

  useEffect(() => {
    if (!tabId && tabs.length > 0) {
      navigate(`${basePath}/${tabs[0].value}`);
    }
  }, [tabId, tabs, navigate]);

  const handleTabChange = (value: string) => {
    navigate(`${basePath}/${value}`);
  };

  const currentTab = tabs.find((tab) => tab.value === tabId);

  if (tabId && !currentTab && tabs.length > 0) {
    return <Navigate to={`${basePath}/${tabs[0].value}`} replace />;
  }

  return (
    <ContentLayout>
      <ContentLayout.Header>
        <ContentLayout.Title>Dashboard</ContentLayout.Title>
      </ContentLayout.Header>

      <ContentLayout.SubHeader>
        <Tabs value={tabId} onChange={handleTabChange} orientation="vertical" keepMounted={false}>
          <Tabs.List>
            {tabs.map((tab) => (
              <Tabs.Tab key={tab.value} value={tab.value}>
                {tab.label}
              </Tabs.Tab>
            ))}
          </Tabs.List>

          {tabs.map((tab) => (
            <Tabs.Panel key={tab.value} value={tab.value}>
              <ScrollArea classNames={classes} offsetScrollbars>
                {tab.component}
              </ScrollArea>
            </Tabs.Panel>
          ))}
        </Tabs>
      </ContentLayout.SubHeader>
    </ContentLayout>
  );
};
